const sortPriceCodes = (priceCodes) => {
  return Object.keys(priceCodes.entities.priceCode).sort((a, b) => {
    return priceCodes.entities.priceCode[a].displayOrder >
      priceCodes.entities.priceCode[b].displayOrder
      ? 1
      : -1;
  });
};

const sortPriceCodesByProperty = (priceCodes, property, value, order) => {
  const comps = [];
  const nonComps = priceCodes.result.reduce((acc, element) => {
    if (priceCodes.entities.priceCode[element][property] === value) {
      comps.push(element);
      return [...acc];
    } else {
      return [...acc, element];
    }
  }, []);
  return order === 'ASC' ? comps.concat(nonComps) : nonComps.concat(comps);
};

export { sortPriceCodes, sortPriceCodesByProperty };



// WEBPACK FOOTER //
// ./src/routes/EventDetails/routes/admissions/modules/helpers/sorting.js